import { RfxTab } from "newui/features/Rfx/types/component-types";
import { RfxSupplierPaths, BaseMemberPaths } from "./navigation.types";

export class SupplierPaths extends BaseMemberPaths {
	shareProfile: string;

	rfx: RfxSupplierPaths;

	constructor(companyId: number) {
		super(companyId);

		this.shareProfile = this.prefixWithBasePath("profile/share");

		this.rfx = {
			all: this.prefixWithBasePath("rfx"),
			accepted: this.prefixWithBasePath("rfx/accepted"),
			awarded: this.prefixWithBasePath("rfx/awarded"),
			submitted: this.prefixWithBasePath("rfx/submitted"),
			unsuccessful: this.prefixWithBasePath("rfx/unsuccessful"),
		};
	}

	viewRfxSubmission(
		rfxId: number,
		submissionId: number,
		tabId: RfxTab | null = null,
		contextId: number | string | null = null
	) {
		const basePath = this.prefixWithBasePath(
			`rfx/${rfxId}/submission/${submissionId}`
		);

		if (!tabId) {
			return basePath;
		}

		return `${basePath}/${tabId}/${contextId ? contextId : ""}`;
	}
}
